module.exports = __webpack_public_path__ + "img/多边形选中.e02b2233.png";